import { memo } from 'react';
import { IconButton, Typography } from '@mui/material';
import { TwitterXIcon, DiscordIcon } from './social_icons';

const linkStyles = {
  color: 'text.primary',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
} as const;

const iconButtonStyles = {
  color: 'text.primary',
} as const;

export const SocialMediaLinks = memo(
  ({ docsUrl, twitterUrl, discordUrl }: { docsUrl?: string; twitterUrl?: string; discordUrl?: string }) => {
    return (
      <>
        <Typography variant="body2" component="a" href={docsUrl} target="_blank" rel="noopener" sx={linkStyles}>
          Docs
        </Typography>
        <IconButton
          size="small"
          component="a"
          href={twitterUrl}
          target="_blank"
          rel="noopener"
          aria-label="Twitter/X"
          sx={iconButtonStyles}
        >
          <TwitterXIcon fontSize="inherit" />
        </IconButton>
        <IconButton
          size="small"
          component="a"
          href={discordUrl}
          target="_blank"
          rel="noopener"
          aria-label="Discord"
          sx={iconButtonStyles}
        >
          <DiscordIcon fontSize="inherit" />
        </IconButton>
      </>
    );
  }
);

SocialMediaLinks.displayName = 'SocialMediaLinks';
